import { FormikProps } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { AddressField } from '../../../../../global/components/form-element/address';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { BeneficiaryOrganizationMailingAddressRequiredSchema } from '../../../../account-info/features/personal-info/personal-form-models';
import { MailingAddressFieldNames } from '../../../../account-info/models/form-models';
import { getAddressLabels } from '../../../../account-info/selectors/form-selectors';
import { BeneficiaryCreateFormModel, CreateOrganizationFormContentModel } from '../model/beneficiary-create-models';
import { BeneficiarySettings } from '../model/epi-props';


interface Props {
	content: CreateOrganizationFormContentModel;
	settings: BeneficiarySettings;
	formProps: FormikProps<BeneficiaryCreateFormModel>;
}
export function CreateBeneficiaryOrganizationFields(props: Props) {

	const { settings, formProps, content } = props;
	const labelSetting = useSelector<TcsmStates, LabelSettingProps>(state => state?.epiProps?.labelSettingState?.epiContent);

	return (
		<>
			<FormGroup>
				<DividerSection
					sectionText={content?.title}
				>
					<ContentSpacer>
						<h2>{content?.description}</h2>
					</ContentSpacer>
					<FormField
						name='org_name'
						label={content?.legalNameLabel}
						component='input'
						touched={formProps.touched}
						errors={formProps.errors}
						required
						tooltip={{
							title: content.legalNameHelperText,
						}}
					/>
					<FormField
						name='tax_id'
						label={settings?.tinLabel}
						component='input'
						touched={formProps.touched}
						errors={formProps.errors}
						mask={[/[0-9]|X/, /\d|X/, /\d|X/, '-', /\d|X/, /\d|X/, '-', /\d/, /\d/, /\d/, /\d/]}
						autoWidth
						tooltip={{
							title: settings?.tinHelperText,
						}}
						required
					/>
					<p className='input-caption'>{settings?.tinSecondaryLabel}</p>
				</DividerSection>
				<DividerSection sectionText={content?.personTitle}>
					<FormField
						name='contact_first_name'
						label={settings?.contactFistNameLabel}
						component='input'
						touched={formProps.touched}
						errors={formProps.errors}
						required
					/>
					<FormField
						name='contact_last_name'
						label={settings?.contactLastNameLabel}
						component='input'
						touched={formProps.touched}
						errors={formProps.errors}
						required

					/>
					<FormField
						name='contact_phone'
						label={settings?.contactPhoneLabel}
						component='input'
						touched={formProps.touched}
						errors={formProps.errors}
						required

					/>
					<FormField
						name='contact_email'
						label={settings?.contactEmailLabel}
						component='input'
						touched={formProps.touched}
						errors={formProps.errors}

					/>
				</DividerSection>
			</FormGroup>
			<DividerSection sectionText={labelSetting.mailingAddressTitle} >
				<AddressField
					currentCountry={formProps?.values?.mailing_country === '' ? 'US' : formProps?.values?.mailing_country}
					labels={getAddressLabels(labelSetting)}
					addressFieldNames={MailingAddressFieldNames}
					formProps={formProps}
					requiredSchema={BeneficiaryOrganizationMailingAddressRequiredSchema}
					person
				/>

			</DividerSection>
			<DividerSection removeDivider>
			<ContentSpacer>
				<h4>{settings?.acknowledgementTitle}</h4>
			</ContentSpacer>
			<div data-formdata='acknowledge'>
				<FormField
					name='acknowledge'
					required
					label={settings?.acknowledgementDescription}
					component='checkBox'
					touched={formProps.touched}
					errors={formProps.errors}
					value={formProps?.values?.acknowledge ?? false}
					checked={formProps?.values?.acknowledge ?? false}
				/>
				</div>
			</DividerSection>
		</>
	);
}
